<canvas class="chart-canvas" [id]="'basiq-monthly-debits-credits-chart' + index" height="400"> </canvas>
